import { AppState } from 'stores/index'
import {
  DesktopDropdown,
  MobileDropdown
} from 'components/selector/dropdownComponents'
import {
  branch,
  predicate,
  renderComponent
} from 'recompose'
import { connect } from 'react-redux'
import { ComponentProps, ComponentType } from 'react'

const showMobileVersion = (hasTouch: predicate<{hasTouch: boolean}>, mobileComponent: ComponentType<ComponentProps<typeof MobileDropdown>>) =>
  branch(hasTouch, renderComponent(mobileComponent))

const enhance = showMobileVersion(props => props.hasTouch, MobileDropdown)

function mapStateToProps({ interactionCapabilities }: AppState) {
  return {
    hasTouch: interactionCapabilities.touch
  }
}

export default connect(mapStateToProps)(enhance(DesktopDropdown))
